/**
 * View controller for the logIn subview.
 * @constructor
 * @extends {Foundation.Component}
 * @param {string} id
 */
Foundation.Login.Dialog.LogInComponent = function (id) {
    Foundation.Component.call(this, id);

    /**
     * @private
     * @type {Foundation.Member}
     */
    this._member = Foundation.Login.Dialog.activeDialog.member()

    /**
     * @private
     * @type {Foundation.Login.Attempt}
     */
    this._loginAttempt = null

    /**
     * @private
     * @type {Foundation.Form}
     */
    this.form = this.registerForm(new Foundation.Form(this.view.find("form")[0]));
    this.form.setSubmitDelegate(this._attemptLogIn.bind(this));
    this.observe("hidden", this.form.cancelSubmit.bind(this.form));

    this.view.find("input[name=email]").change(this._emailChanged.bind(this));
};
Foundation.inherit(Foundation.Login.Dialog.LogInComponent, Foundation.Component);

/**
 * Get the active login attempt object.
 * @private
 * @return {Foundation.Login.Attempt}
 */
Foundation.Login.Dialog.LogInComponent.prototype._activeLoginAttempt = function () {
    if (!this._loginAttempt || this._loginAttempt.isFailed()) {
        this._loginAttempt = new Foundation.Login.Attempt(this._member)
    }
    return this._loginAttempt
}

/**
 * Update the login attempt object with the email address we're likely to
 * use to attempt to log in. In a previous life, doing this allowed it to
 * prefetch a password challenge, but all that code is gone.
 */
Foundation.Login.Dialog.LogInComponent.prototype._emailChanged = function () {
    var emailAddress = /** @type {string} */ (this.form.values()["email"]);
    this._activeLoginAttempt().forEmail(emailAddress);
};

/**
 * Handle the user log in form submission.
 * @param {Object.<string,*>} vals
 * @return {!Foundation.Promise}
 */
Foundation.Login.Dialog.LogInComponent.prototype._attemptLogIn = function (vals) {
    this._member.set("email", vals["email"]);

    var ttl = vals["remember"] ? Foundation.Login.STAY_LOGGED_IN_TTL
                               : Foundation.Login.SESSION_COOKIE_TTL

    var attempt = this._activeLoginAttempt()
    attempt.forEmail(/** @type {string} */ (vals["email"]))
    attempt.withPassword(/** @type {string} */ (vals["password"]))
    attempt.sessionLasts(ttl)
    attempt.usesSessionOnlyCookie(!(vals["remember"]))
    return attempt.performAttempt()
};
